// Dependencies
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
// Actions
import { updateReference } from './redux/actions';
// Types
import { AppState } from '../../reducers';
import { Circuit } from './objects/circuit';
import { FormHelperText } from '@mui/material';
import { updateCircuitInfoErrors } from './redux/reducer';

type Props = {
    circuit: Circuit | null
}

export function CircuitReference(props: Props): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const circuitData = useSelector((state: AppState) => state.circuit.circuit);
    const reference = useSelector((state: AppState) => state.circuit.reference);
    const circuit_info_errors = useSelector((state: AppState) => state.circuitSlice.circuit_info_errors);

    useEffect(() => {
        dispatch(updateReference(reference ? reference: ''));
    },[circuitData]);

    const onReferenceChange = (event: { target: { value: any; }; }) => {
        dispatch(updateReference(event.target.value));
        dispatch(updateCircuitInfoErrors({ ...circuit_info_errors, reference: '' }));
    };

    // recreate input
    useEffect(() => {
        if (props.circuit) {
            dispatch(updateReference(props.circuit.reference ?? ''));
        }
    }, [props.circuit]);

    return (
        <FormControl fullWidth variant={ 'outlined' } error={!!circuit_info_errors.reference}>
            <TextField
                value={ reference }
                error={!!circuit_info_errors.reference}
                id={ 'circuit-reference' }
                label={ t('shared.reference') }
                onChange={ onReferenceChange }
                required
            />
            <FormHelperText>{circuit_info_errors.reference}</FormHelperText>
        </FormControl>
    );
}

export default CircuitReference;
